// Port of api/fuel/app/classes/insights/hindex/games.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'games',
    priority: 1,
    default_: true,
    requires: ['init'],
    insight: [],
    detail: [],
    types: [Constants.TYPE_USER, Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!this._data.track || !this._data.track.get_hindex()) return {}

        var levelAdded = {}
        var levelRemoved = {}
        var allIndex = {}

        var allLevels = Util.query(
            'SELECT * FROM log_user_hindex WHERE hindex_id = ' + this._data.type.get_id() +
            ' AND user_id = ' + owner.get_id() +
            ' ORDER BY log_hindex ASC'
        )

        for (var li = 0; li < allLevels.length; li++) {
            var level = allLevels[li]
            var levelIds = Util.parse_id_list(level.log_index_level)
            var levelHindex = String(level.log_hindex)

            for (var lj = 0; lj < levelIds.length; lj++) {
                var gid = levelIds[lj]
                allIndex[gid] = true
                if (!levelAdded[gid] || levelRemoved[gid] < levelHindex - 1) levelAdded[gid] = levelHindex
                levelRemoved[gid] = levelHindex
            }
        }

        var allIndexKeys = Object.keys(allIndex).map(function(k) { return parseInt(k, 10) })

        var currentLevel = this._data.current.get_hindex()
        var currentIndexLevel = this._data.current.get_index_level()

        // Games at current level
        var games = []
        var sorted = Util.query(
            'SELECT p.game_id as g, SUM(p.play_count) AS c, MIN(p.play_date) AS f, MAX(p.play_date) AS d' +
            ' FROM play p, game g' +
            ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
            ' AND p.game_id = g.game_id AND g.game_type = 1' +
            ' AND g.game_id IN(' + Util.in(currentIndexLevel) + ')' +
            this._data.playFilter +
            ' GROUP BY p.game_id' +
            ' HAVING SUM(p.play_count) >= ' + currentLevel +
            ' ORDER BY SUM(p.play_count) DESC, g.game_name ASC'
        )

        for (var i = 0; i < sorted.length; i++) {
            var item = sorted[i]
            games.push({
                a: levelAdded[item.g] !== undefined ? levelAdded[item.g] : false,
                g: parseInt(item.g, 10),
                c: parseInt(item.c, 10),
                d: parseInt(item.d, 10),
                f: parseInt(item.f, 10)
            })
            this._references.games.push(item.g)
        }

        // Latecomers (games that qualify but aren't in the current index)
        var latecomers = []
        sorted = Util.query(
            'SELECT p.game_id as g, SUM(p.play_count) AS c, MIN(p.play_date) AS f, MAX(p.play_date) AS d' +
            ' FROM play p, game g' +
            ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
            ' AND p.game_id = g.game_id AND g.game_type = 1' +
            ' AND g.game_id NOT IN(' + Util.in(currentIndexLevel) + ')' +
            this._data.filter + this._data.playFilter +
            ' GROUP BY p.game_id' +
            ' HAVING SUM(p.play_count) >= ' + currentLevel +
            ' ORDER BY SUM(p.play_count) DESC, g.game_name ASC'
        )

        for (var j = 0; j < sorted.length; j++) {
            latecomers.push({
                g: parseInt(sorted[j].g, 10),
                c: parseInt(sorted[j].c, 10),
                d: parseInt(sorted[j].d, 10),
                f: parseInt(sorted[j].f, 10)
            })
            this._references.games.push(sorted[j].g)
        }

        // Near (games one play away)
        var near = []
        sorted = Util.query(
            'SELECT p.game_id as g, SUM(p.play_count) AS c, MIN(p.play_date) AS f, MAX(p.play_date) AS d' +
            ' FROM play p, game g' +
            ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
            ' AND p.game_id = g.game_id AND g.game_type = 1' +
            this._data.filter + this._data.playFilter +
            ' GROUP BY p.game_id' +
            ' HAVING SUM(p.play_count) = ' + (currentLevel - 1) +
            ' ORDER BY SUM(p.play_count) DESC, g.game_name ASC'
        )

        for (var k = 0; k < sorted.length; k++) {
            near.push({
                g: parseInt(sorted[k].g, 10),
                c: parseInt(sorted[k].c, 10),
                d: parseInt(sorted[k].d, 10),
                f: parseInt(sorted[k].f, 10)
            })
            this._references.games.push(sorted[k].g)
        }

        // Past (games that were in a previous level but not the current)
        var past = []
        sorted = Util.query(
            'SELECT p.game_id as g, SUM(p.play_count) AS c, MIN(p.play_date) AS f, MAX(p.play_date) AS d' +
            ' FROM play p, game g' +
            ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
            ' AND p.game_id = g.game_id AND g.game_type = 1' +
            ' AND g.game_id IN(' + Util.in(allIndexKeys) + ')' +
            ' AND g.game_id NOT IN(' + Util.in(currentIndexLevel) + ')' +
            this._data.playFilter +
            ' GROUP BY p.game_id' +
            ' ORDER BY SUM(p.play_count) DESC, g.game_name ASC'
        )

        for (var pi = 0; pi < sorted.length; pi++) {
            past.push({
                a: levelRemoved[sorted[pi].g],
                g: parseInt(sorted[pi].g, 10),
                c: parseInt(sorted[pi].c, 10),
                d: parseInt(sorted[pi].d, 10),
                f: parseInt(sorted[pi].f, 10)
            })
            this._references.games.push(sorted[pi].g)
        }

        // Next candidates
        var candidates = []
        sorted = Util.query(
            'SELECT p.game_id as g, SUM(p.play_count) AS c, MIN(p.play_date) AS f, MAX(p.play_date) AS d' +
            ' FROM play p, game g' +
            ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
            ' AND p.game_id = g.game_id AND g.game_type = 1' +
            this._data.filter + this._data.playFilter +
            ' GROUP BY p.game_id' +
            ' HAVING SUM(p.play_count) < ' + (currentLevel + 1) +
            ' ORDER BY SUM(p.play_count) DESC, g.game_name ASC' +
            ' LIMIT 0, 5'
        )

        for (var ci = 0; ci < sorted.length; ci++) {
            candidates.push({
                g: parseInt(sorted[ci].g, 10),
                c: parseInt(sorted[ci].c, 10),
                d: parseInt(sorted[ci].d, 10),
                f: parseInt(sorted[ci].f, 10)
            })
            this._references.games.push(sorted[ci].g)
        }

        return {
            games: {
                level: games,
                latecomers: latecomers,
                past: past,
                near: near,
                next: candidates
            }
        }

    }
})
